import React from 'react';
import {Tag} from 'antd';
import utils from '../../utils';
import fetch from '../fetch';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号',
    },
    {
        key: 'targetName',
        label: '审核指标',
    },
    {
        key: 'courseName',
        label: '课程名称'
    },
    {
        key: 'employeeName',
        label: '任课教师'
    },
    {
        key: 'enteringEmployeeName',
        label: '录入人'
    },
    {
        key: 'orgName',
        label: '所属部门'
    },
    {
        key: 'majorName',
        label: '所属专业'
    },
    {
        key: 'status',
        label: '状态',
        width: 120,
        render: (val) => {
            if(val === 1) {
                return <Tag color="#108ee9">已填写</Tag>
            } else if(val === 2) {
                return <Tag color="#87d068">已审核</Tag>
            } else if(val === 3) {
                return <Tag color="#f50">审核不通过</Tag>
            }
        }
    },
    {
        key: 'coursePropertyName',
        label: '课程性质',
    },
    {
        key: 'courseFormsName',
        label: '课程形式'
    },
    {
        key: 'createTime',
        label: '提交时间',
    },
    {
        key: 'termName',
        label: '学期',
        width: 150
    },
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('course/assess/audit/list?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code === 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data || []).length ? '' : '暂无数据...'
        }))
    )
}

const save = (data) => {
    return fetch.post('course/assess/audit/pass/save', data)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

const noPassSave = (data) => {
    return fetch.post('course/assess/audit/no/pass/save', data)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

const back = (id) => {
    return fetch.get(`course/assess/audit/back/${id}`)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

export default {
    download: fetch.base + 'course/assess/result/file/download?id=',
    setRefresh,
    onSelect,
    getSelection,
    columns,
    querySearch,
    save,
    noPassSave,
    back
}